<div class="flex flex-col gap-3">
	<ui-input
		appKeyboard
		class="w-full [&_.ui-input-shell]:min-h-11! [&_input]:[direction:ltr]"
		labelPosition="inside"
		[id]="'order-quantity'"
		[label]="quantityLabel"
		[error]="hasError()"
		[class.[&_input]:text-red-500!]="hasError()"
		[attr.aria-invalid]="hasError()"
		[step]="1"
		[stepValue]="1"
		[readOnly]="true"
		[ngModel]="formattedQuantity()"
		(ngModelChange)="onQuantityInput($event)">
		<div class="flex items-center gap-0.5 -ms-1.5" dir="ltr">
			<div class="inline-flex min-w-16 flex-col items-stretch gap-0.5 ps-px">
				<div
					role="button"
					class="flex h-4.5 cursor-pointer items-center justify-start gap-0.5 rounded-sm rounded-tl-md bg-gray-950/10 px-px text-2.75 font-medium leading-none text-gray-700"
					(click)="onMaxQuantity()">
					<ui-icon
						class="inline-flex shrink-0 items-center justify-center"
						width="16"
						height="16"
						iconName="chevron-up"
						color="text-gray-500" />
					@if (maxQuantity() !== undefined) {
						<ui-number
							class="inline-flex items-center leading-none whitespace-nowrap"
							[value]="maxQuantity()" />
					}
				</div>
				<div
					role="button"
					class="flex h-4.5 cursor-pointer items-center justify-start gap-0.5 rounded-sm rounded-bl-md bg-gray-950/10 px-px text-2.75 font-medium leading-none text-gray-700"
					(click)="onMinQuantity()">
					<ui-icon
						class="inline-flex shrink-0 items-center justify-center"
						width="16"
						height="16"
						iconName="chevron-down"
						color="text-gray-500" />
					@if (minQuantity() !== undefined) {
						<ui-number
							class="inline-flex items-center leading-none whitespace-nowrap"
							[value]="minQuantity()" />
					}
				</div>
			</div>
			<ui-button
				variant="ghost"
				class="mx-0.5 flex h-9.5 w-9.5 items-center justify-center rounded-lg"
				size="md"
				iconOnly
				label="ماشین حساب"
				[ariaPressed]="calculatorOpen()"
				[class.bg-gray-500/10]="calculatorOpen()"
				(click)="toggleCalculator()">
				<ui-icon [iconName]="calculatorIcon()" />
			</ui-button>
		</div>
	</ui-input>

	@if (calculatorOpen()) {
		<app-order-calculator />
	}
</div>
